enum DialogueThemesEnum {
  LightTheme = 1,
  DarkTheme = 2,
  MultiColorTheme = 3,
}
export default Object.freeze(DialogueThemesEnum);

